import { render, staticRenderFns } from "./CompanyFeatures.vue?vue&type=template&id=72d17592&scoped=true"
import script from "./CompanyFeatures.vue?vue&type=script&lang=js"
export * from "./CompanyFeatures.vue?vue&type=script&lang=js"
import style0 from "./CompanyFeatures.vue?vue&type=style&index=0&id=72d17592&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d17592",
  null
  
)

export default component.exports